<template>
    <div>
        <div id="header-container" class="px-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-0">
                <h3 class="text-white">{{ $t('Resubmit Form') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0 pb-5">
                            <div class="p-2 mb-4">
                                <div class="py-3">
                                    <BasicInfo
                                        class="block-item bg-grey2 p-3"
                                        :provinceOpt="provinceOpt"
                                        @file-uploaded = "fileUploaded"
                                        :accountId = "formData.accountId"
                                        :userNo = "userNo"
                                        ref="basicInfo"
                                    ></BasicInfo>

                                    <RegisterInfo
                                        class="block-item bg-grey2 p-3"
                                        :provinceOpt="provinceOpt"
                                        @file-uploaded = "fileUploaded"
                                        ref="registerInfoHongkong"
                                        :accountId = "formData.accountId"
                                        :userNo = "userNo"
                                    ></RegisterInfo>

                                    <div class="mb-5 block-item bg-grey2 p-3">
                                        <div class="d-flex">
                                            <h5>{{ $t('Director Information') }}</h5>
                                        </div>
                                        <hr>
                                        
                                        <div class="px-3 mb-3 mt-3">
                                            <DirectorInfo
                                                ref='directorInfo'
                                                @file-uploaded = "fileUploaded"
                                                :doc_type_list = document
                                                :provinceOpt="provinceOpt"
                                                :accountId = "formData.accountId"
                                                :userNo = "userNo"
                                            ></DirectorInfo>
                                        </div>
                                    </div>

                                    <div class="mb-3 block-item bg-grey2 p-3">
                                        <div class="d-flex">
                                            <h5>{{ $t('Beneficiary Information') }}</h5>
                                            <span class="position-relative">
                                                <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                                                <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                                                </button>
                                                <NewPopupInfo :name="'beneficiary'" v-if="showPopup"></NewPopupInfo>
                                            </span>
                                        </div>
                                        <hr>
                                        
                                        <div class="px-3 mb-3 mt-3">
                                            <div v-for="(item,index) in beneficary_list" :key="item.id">
                                                
                                                <BeneficiaryInfo 
                                                    :ref="'beneficiary'+item.id"
                                                    :index="index"
                                                    :is_new="item.is_new"
                                                    @file-uploaded = "fileUploaded"
                                                    :provinceOpt="provinceOpt"
                                                    :doc_type_list = document
                                                    :is_remove = "beneficary_list.length>1?true:false"
                                                    :accountId = "formData.accountId"
                                                    :userNo = "userNo"
                                                ></BeneficiaryInfo>

                                                <hr>
                                                <div class="d-flex justify-content-end mb-2">
                                                    <div class="mb-0">
                                                        
                                                        <div class="w-100 ml-auto d-flex justify-content-end mb-3">
                                                            <button v-if="beneficary_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItem(item.id)">
                                                                <span>Remove</span>
                                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                                            </button>
                                                            <button class="btn btn-outline-orange" @click="addBeneficiary">Add +</button>
                                                        </div>

                                                    </div>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="text-right mt-3">
                                    <button class="btn btn-primary" @click="submitAccount">Submit</button>
                                </div>

                                <LoaderComponent v-if="isLoading"></LoaderComponent>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>
<script>


import BeneficiaryInfo from '@/components/Resubmit/Hongkong/BeneficiaryInfo.vue';
import BasicInfo from '@/components/Resubmit/Hongkong/BasicInfo.vue';
import RegisterInfo from '@/components/Resubmit/Hongkong/RegisterInfo.vue';
import DirectorInfo from '@/components/Resubmit/Hongkong/DirectorInfo.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import LoaderComponent from "@/components/LoaderComponent";

export default {
    name: 'resubmit',
    data() {
        return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            beneficary_list:[],
            provinceOpt:[],
            isLoading:false,
            showPopup:false,
            can_submit:true,
            formData:{},
            basic_info:{},
            director_info:{},
            beneficary_data:[],
            userNo:'',
            document:[
                {
                    "id":1,
                    "name":"Identity Card"
                },
                {
                    "id":2,
                    "name":"Passport"
                }
            ]
        }
    },
    components: {
        LoaderComponent,
        BeneficiaryInfo,
        BasicInfo,
        DirectorInfo,
        NewPopupInfo,
        RegisterInfo
    },
    methods:{
        submitAccount(){
            let is_valid = true;
            let self = this;
            this.isLoading = true;

            if(!this.$refs['basicInfo'].validate()){
                console.log("basic info belum valid");
                is_valid = false;
            }

            if(!this.$refs['directorInfo'].validate()){
                console.log("director info belum valid");
                is_valid = false;
            }

            for(let i=0;i<this.beneficary_list.length;i++){
                let ref = 'beneficiary'+this.beneficary_list[i].id;
                if(!this.$refs[ref][0].validate()){
                    console.log("beneficiary belum valid");
                    is_valid = false;
                }
            }

            if(is_valid){
                self.uploadPhoto();
            }
            else{
                this.isLoading = false;
            }
        },
        removeItem(id) {
            const index = this.beneficary_list.findIndex(item => item.id === id)
            if (index !== -1) {
                this.beneficary_list.splice(index, 1)
            }
        },
        addBeneficiary(){
            this.beneficary_list.push({
                "id":(this.beneficary_list[this.beneficary_list.length-1].id+1),
                "is_new":true
            });
        },
        uploadPhoto(){
            this.$refs['basicInfo'].uploadFile();
            this.$refs['directorInfo'].uploadFile();

            for(let i=0;i<this.beneficary_list.length;i++){
                let ref = 'beneficiary'+this.beneficary_list[i].id;
                this.$refs[ref][0].uploadFile();
            }
        },
        fileUploaded(){
            let beneficiary_completed = true;
            let have_failed = false;
            for(let i=0;i<this.beneficary_list.length;i++){
                let ref = 'beneficiary'+this.beneficary_list[i].id;
                if(this.$refs[ref][0].success==null){
                    beneficiary_completed = false;
                    break;
                }
                if(this.$refs[ref][0].success === false){
                    have_failed = true;
                    break;
                }
            }

            if(
                this.$refs['basicInfo'].success!=null &&
                this.$refs['directorInfo'].success!=null && 
                beneficiary_completed
            ){
                if(
                    this.$refs['basicInfo'].success === false ||
                    this.$refs['directorInfo'].success === false || have_failed === true
                ){
                    this.isLoading = false;
                }
                else if(
                    this.$refs['basicInfo'].success === true &&
                    this.$refs['directorInfo'].success === true && have_failed === false &&
                    this.can_submit === true
                ){
                    this.can_submit = false;
                    this.submitData();
                }
            }
        },
        submitData(){

            let basic_info = this.$refs['basicInfo'];
            let register_info = this.$refs['registerInfoHongkong'];
            let director_info = this.$refs['directorInfo'];

            let params = {
                "accountId":this.formData.accountId,
                "name":basic_info.params.name,
                "enName":basic_info.params.enName,
                "province":basic_info.params.province,
                "city":basic_info.params.city,
                "area":basic_info.params.area,
                "address":basic_info.params.address,
                "orgRegister":basic_info.file.orgRegister,
                "orgRegisterNo" : basic_info.params.orgRegisterNo,
                "declarationForm" : basic_info.file.declarationForm,
                "incorporationForm" : basic_info.file.incorporationForm,
                "businessRegister" : basic_info.file.businessRegister,
                "businessRegisterExpiryDate" : basic_info.params.businessRegisterExpiryDate,
                "businessRegisterNo" : basic_info.params.businessRegisterNo,
                "stockCertificate" : basic_info.file.stockCertificate,
                "registerDate":register_info.params.registerDate,
                "registerAmt" : register_info.params.registerAmt,
                "registerProvince" : register_info.params.registerProvince,
                "registerCity" : register_info.params.registerCity,
                "registerArea" : register_info.params.registerArea,
                "registerAddress" : register_info.params.registerAddress,
                "directorName":director_info.params.directorName,
                "directorBirthDate":director_info.params.directorBirthDate,
                "directorIdNo":director_info.params.directorIdNo,
                "directorIdType":director_info.params.directorIdType,
                "directorIdFront":director_info.file.directorIdFront,
                "directorIdReverse":director_info.file.directorIdReverse,
                "directorIdHold":director_info.file.directorIdHold,
                "directorCertExpiryDate":director_info.params.directorCertExpiryDate,
                "directorCountryCode":"HKG",
                "directorProvince":director_info.params.directorProvince,
                "directorCity":director_info.params.directorCity,
                "directorArea":director_info.params.directorArea,
                "directorAddress":director_info.params.directorAddress,
                "beneficiaryIdFront":[],
                "beneficiaryIdReverse":[],
                "beneficiaryIdType":[],
                "beneficiaryIdNo":[],
                "beneficiaryName":[],
                "beneficiaryBirthDate":[],
                "beneficiaryCertExpiryDate":[],
                "beneficiaryCountry":[],
                "beneficiaryProvince":[],
                "beneficiaryCity":[],
                "beneficiaryArea":[],
                "beneficiaryAddress":[],
                "beneficiaryShareholderRatio":[],
            };

            for(let i=0;i<this.beneficary_list.length;i++){
                let ref = 'beneficiary'+this.beneficary_list[i].id;
                params['beneficiaryIdFront'].push(this.$refs[ref][0].file.beneficiaryIdFront);
                params['beneficiaryIdReverse'].push(this.$refs[ref][0].file.beneficiaryIdReverse);
                params['beneficiaryIdType'].push(this.$refs[ref][0].params.beneficiaryIdType);
                params['beneficiaryIdNo'].push(this.$refs[ref][0].params.beneficiaryIdNo);
                params['beneficiaryName'].push(this.$refs[ref][0].params.beneficiaryName);
                params['beneficiaryBirthDate'].push(this.$refs[ref][0].params.beneficiaryBirthDate);
                params['beneficiaryCertExpiryDate'].push(this.$refs[ref][0].params.beneficiaryCertExpiryDate);
                params['beneficiaryCountry'].push("HKG");
                params['beneficiaryProvince'].push(this.$refs[ref][0].params.beneficiaryProvince);
                params['beneficiaryCity'].push(this.$refs[ref][0].params.beneficiaryCity);
                params['beneficiaryArea'].push(this.$refs[ref][0].params.beneficiaryArea);
                params['beneficiaryAddress'].push(this.$refs[ref][0].params.beneficiaryAddress);
                params['beneficiaryShareholderRatio'].push(this.$refs[ref][0].params.beneficiaryShareholderRatio);
            }

            CreateAccount.hongkong(params).then(response => {
                const data = response.data.data;
                this.isLoading = false;
                this.$swal({
                    icon: 'success',
                    title: 'success',
                    showConfirmButton: true,
                }).then((result) => {
                    this.$router.push({ path: '/list-account' });
                });
            }).catch(err => {
                this.can_submit = true;
                this.checkError(err);
            });
        },
        togglePopup(){
            this.showPopup=!this.showPopup;
        },
        getMessage: function (key) {
            return this.$t(key)
        },
        checkError(err){
            let self = this;
            try{
                this.isLoading = false;
                const response = err.response;  
                if(response.status == 400){
                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            let basic_info = this.$refs['basicInfo'];
                            let director_info = this.$refs['directorInfo'];

                            Object.keys(response.data.message).forEach((key) => {
                                let error = response.data.message[key][0];
                                
                                if(typeof basic_info.error[key] !== "undefined"){
                                    basic_info.error[key] = error;
                                }
                                else if(typeof director_info.error[key] !== "undefined"){
                                    director_info.error[key] = error;
                                }
                                
                                ret.push(error);
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }catch(e){
                console.log(err);
            }
        }
    },
    mounted(){
        CreateAccount.getProvince({"country":"HKG"}).then(response => {
            const data = response.data.data;
            this.provinceOpt = [];
            data.forEach(item => {
                this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
            });
        }).catch(err => {
            this.checkError(err);
        });

        CreateAccount.list({
            search:self.search,
            start:0,
            length:-1
        }).then((response)=>{
            if (response.status == 200) {
                self.isLoading = false;
                this.formData = response.data.data[0]['information'];
                this.userNo = response.data.data[0].userNo;
                this.beneficary_list = [];
                for(let i=0;i<this.formData['beneficiaryIdNo'].length;i++){
                    this.beneficary_list.push({
                        "id":(i+1),
                        "is_new":false
                    });
                }
            }
        });
    }
};
</script>
